const goToCheckoutButton = document.querySelector(".go-to-checkout-button");
const validItemsError = document.querySelector(".valid-items-error");
const unsellableItemsError = document.querySelector(".unsellable-items-error");
const tooHighCartAmountError = document.querySelector(".too-high-cart-amount-error");
const tooManyItemsError = document.querySelector(".too-many-items-error");
const tooHighAndTooManyError = document.querySelector(".too-high-too-many-error");

function validateCart(itemsInCart) {
  const maxCartAmount = sessionStorage.getItem('settings-max-cart-amount');
  const maxTradeinItems = sessionStorage.getItem('setting-max-number-items');
  const rules = [
    {
      isFailed: itemsInCart.every(item => item.isInitiatedConditionUnsellable),
      errorMessage: unsellableItemsError,
    },
    {
      isFailed: itemsInCart.every(item => !item.tradeinValueHigh),
      errorMessage: validItemsError,
    },
    {
      isFailed: maxCartAmount > -1
        && maxCartAmount < itemsInCart.reduce((acc, item) => {
          acc += item.tradeinValueHigh;
          return acc;
        }, 0),
      errorMessage: tooHighCartAmountError,
    },
    {
      isFailed: maxTradeinItems > -1 && maxTradeinItems < itemsInCart.length,
      errorMessage: tooManyItemsError,
    },
  ];
  let isTooHigh = false;
  let isTooMany = false;
  let allUnsellable = false;
  let allIneligible = false;
  rules.forEach(({ isFailed, errorMessage }) => {
    if (isFailed) {
      switch (errorMessage) {
        case tooHighCartAmountError:
          isTooHigh = true;
          break;
        case tooManyItemsError:
          isTooMany = true;
          break;
        case unsellableItemsError:
          allUnsellable = true;
          break;
        case validItemsError:
          allIneligible = true;
          break;
        default:
          break;
      }
    }
    if (isTooHigh && isTooMany) {
      tooHighAndTooManyError?.classList.remove('hidden');
      tooHighCartAmountError?.classList.add('hidden');
      tooManyItemsError?.classList.add('hidden');
    } else {
      errorMessage?.classList[isFailed ? 'remove' : 'add']('hidden');
      tooHighAndTooManyError?.classList.add('hidden');
      if (allUnsellable && allIneligible) {
        // when both the allUnsellable and allIneligible errors are hit,
        // we only need to show the allUnsellable error message to the user
        validItemsError?.classList.add('hidden');
      }
    }
  });
  if (goToCheckoutButton) {
    goToCheckoutButton.disabled = rules.find(rule => rule.isFailed);
  }
}

async function fetchItemsInCart() {
  const tradeinUuid = localStorage.getItem('tradeinUuid');
  if (tradeinUuid) {
    const tradein = await getTradein(tradeinUuid);
    return Promise.resolve(tradein.tradeinItems || []);
  }

  return [];
}

async function renderCart() {
  const itemsInCart = await fetchItemsInCart();
  let shippingEstimate = await getShippingEstimate(global.partnerUuid);
  const itemList = document.querySelector('.trade-in-cart trade-in-item-list');
  itemList?.renderTradeInItems(itemsInCart);

  validateCart(itemsInCart);

  if (itemsInCart.length === 0) {
    document.querySelector('.trade-in-cart__empty')?.classList.remove('hidden');
  } else {
    document.querySelector('.trade-in-cart__with_items')?.classList.remove('hidden');
    const itemList = document.querySelector('trade-in-item-list');
    itemList.renderTradeInItems(itemsInCart);

    // Render header number of items
    const numberOfItemsHeader = document.querySelector('.trade-in-cart trade-in-cart-item-count');
    numberOfItemsHeader?.renderNumberCartItems(itemsInCart.length);

    // Render footer elements
    const tradeInCartFooters = document.querySelectorAll('.trade-in-cart trade-in-cart-footer');
    tradeInCartFooters.forEach(footer => footer.renderFooter(itemsInCart, shippingEstimate));
    const tradeinPromoDetails = JSON.parse(sessionStorage.getItem("tradeinPromoDetails"));
    if (tradeinPromoDetails) {
      const modalTermsAndConditionsContent = document.querySelector('.modal-terms-and-conditions__content');
      modalTermsAndConditionsContent.textContent = tradeinPromoDetails.tradeinPromoDetails?.termsAndConditions;
    }
  }
  return itemsInCart;
}

async function renderShippingCart() {
  const itemsInCart = await renderCart();
  let shippingEstimate = await getShippingEstimate(global.partnerUuid);
  const expandIcon = document.querySelector('.expand-icon');
  const collapseIcon = document.querySelector('.collapse-icon');
  const collapsibleRowTitleHideEl = document.querySelector('.tradein-collapsible-row__title_hide');
  const collapsibleRowTitleShowEl = document.querySelector('.tradein-collapsible-row__title_show');
  const displayHideString = () => {
    collapsibleRowTitleHideEl.classList.remove('hidden');
    collapsibleRowTitleShowEl.classList.add('hidden');
  }
  const displayShowString = () => {
    collapsibleRowTitleHideEl.classList.add('hidden');
    collapsibleRowTitleShowEl.classList.remove('hidden');
  }
  collapsibleRowTitleShowEl.addEventListener('click', () => {
    displayHideString();
  });
  expandIcon.addEventListener('click', () => {
    displayHideString();
  });
  collapsibleRowTitleHideEl.addEventListener('click', () => {
    displayShowString();
  });
  collapseIcon.addEventListener('click', () => {
    displayShowString();
  });

  const potentialCreditMobileEl = document.querySelector('.tradein-collapsible-row__estimates .trade-in-credit-estimate');
  const estimatedShippingMobileEl = document.querySelector('.tradein-collapsible-row__estimates .trade-in-shipping-estimate');
  const estimateGiftcardMobileEl = document.querySelector('.tradein-collapsible-row__estimates .trade-in-giftcard-estimate');

  const potentialCreditEl = document.querySelector('.trade-in-cart .trade-in-credit-estimate');
  const estimatedShippingEl = document.querySelector('.trade-in-cart .trade-in-shipping-estimate');
  const estimateGiftcardEl = document.querySelector('.trade-in-cart .trade-in-giftcard-estimate');


  const {
    potentialCreditLow,
    potentialCreditHigh,
    potentialCreditHighDisplay,
  } = calculatePotentialCredit(itemsInCart);
  const { giftcardEstimateLow, giftcardEstimateHigh } = calculateGiftcardEstimate({
    potentialCreditLow,
    potentialCreditHigh,
    shippingEstimate,
  });

  const collapsibleRowEstimateWrapper = document.querySelector('.tradein-collapsible-row__estimate');
  if (collapsibleRowEstimateWrapper) {
    setPrice(collapsibleRowEstimateWrapper, [potentialCreditLow, potentialCreditHigh]);
  }

  setPrice(potentialCreditMobileEl, [potentialCreditLow, potentialCreditHigh]);
  if (estimatedShippingMobileEl) setShippingPrice(estimatedShippingMobileEl, shippingEstimate);
  if (estimateGiftcardMobileEl) setPrice(estimateGiftcardMobileEl, [giftcardEstimateLow, giftcardEstimateHigh]);

  setPrice(potentialCreditEl, [potentialCreditLow, potentialCreditHigh]);
  if (estimatedShippingEl) setShippingPrice(estimatedShippingEl, shippingEstimate);
  if (estimateGiftcardEl) setPrice(estimateGiftcardEl, [giftcardEstimateLow, giftcardEstimateHigh]);

  if (potentialCreditHigh !== potentialCreditHighDisplay) {
    const promotionBonusValue = potentialCreditHigh - potentialCreditHighDisplay;
    const promotionBonusEls = document.querySelectorAll('.trade-promotion-bonus-wrap');
    promotionBonusEls.forEach(promotionBonusEl => {
      const promotionBonusValueEl = promotionBonusEl.querySelector('.tradein-in-promotion-value');
      setSinglePrice(promotionBonusValueEl, promotionBonusValue);
      setPrice(potentialCreditEl, [potentialCreditLow - promotionBonusValue, potentialCreditHigh - promotionBonusValue]);
      setPrice(potentialCreditMobileEl, [potentialCreditLow - promotionBonusValue, potentialCreditHigh - promotionBonusValue]);
      promotionBonusEl.classList.remove('hidden');
    });
    const modalTermsAndConditionsOpeners = document.querySelectorAll('.modal-terms-and-conditions-opener');
    modalTermsAndConditionsOpeners.forEach((modalTermsAndConditionsOpener) => {
      modalTermsAndConditionsOpener.classList.remove('hidden');
    });
  }
}

async function goToShippingPage () {
  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-shipping-2`);
};

renderCart();

goToCheckoutButton?.addEventListener('click', goToShippingPage);
